import { render, staticRenderFns } from "./videoConfModal.vue?vue&type=template&id=bf8b0fc6&scoped=true&lang=pug"
import script from "./videoConfModal.vue?vue&type=script&lang=js"
export * from "./videoConfModal.vue?vue&type=script&lang=js"
import style0 from "./videoConfModal.vue?vue&type=style&index=0&id=bf8b0fc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8b0fc6",
  null
  
)

export default component.exports